import {
  ApiService,
} from '@/internal';

export default class FeatureIdeaService extends ApiService {

  prompt(payload = {}) {

    const {params} = payload;

    return this.request({
      method: 'get',
      url: '/feature-ideas/prompt',
      params: this.prepareParams(params),
    });
  }

  store(payload = {}) {

    const {params, ...rest} = payload;

    return this.request({
      method: 'post',
      url: '/feature-ideas',
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }

  dismiss(payload = {}) {

    const {params, ...rest} = payload;

    return this.request({
      method: 'post',
      url: '/feature-ideas/prompt/dismiss',
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }

  viewed(payload = {}) {

    const {params, ...rest} = payload;

    return this.request({
      method: 'post',
      url: '/feature-ideas/prompt/viewed',
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }

  vote(id, payload = {}) {

    const {params, ...rest} = payload;

    return this.request({
      method: 'post',
      url: `/feature-ideas/${id}/vote`,
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }
}
